// extracted by mini-css-extract-plugin
export default {"player":"detalleplayer_player__dB3xt","monu":"detalleplayer_monu__cUoSr","pImg":"detalleplayer_pImg__zG6wN","data":"detalleplayer_data__EmJpb","test":"detalleplayer_test__WQrJq"};